import(/* webpackMode: "eager", webpackExports: ["Contact"] */ "/vercel/path0/frontend_next/src/screens/user/Contact.tsx");
